export type MachineMode = 'empty-carousel' | 'inspect-machine' | 'stereo-check';

export enum CalibrationStep {
  Setup,
  CollectData,
  ReviewMetric,
  TrainError,
}

export enum ResetPlateMode {
  // i.e. DEFAULT_PLATE
  Default = 'Default',
  // plate based on traj from pitch
  PitchTraj = 'PitchTraj',
  // plate based on backup value
  PitchBackup = 'PitchBackup',
  // i.e. do not change the plate location
  Skip = 'Skip',
}

// whether to use the ABS-adjusted location based on backup location (relative to DEFAULT_PLATE)
export const USE_ABS_PITCH_BACKUP = false;

// parent to fire button, onReady result
export enum FireInstruction {
  DoNothing,
  AutoFire,
  GoToReady,
}

// ! deprecate, whether optimize pitch, edit breaks, edit spins are shown as menu actions
export const ALLOW_CLOSED_LOOP_TRAINING = false;
